import { INVITE_CODE_LENGTH, normalizeInviteCode } from '@sorrem/shared';
import { Button, Textbox } from '@sorrem-client/ui/components';
import { useState, type FormEvent } from 'react';
import styles from './InviteCodeForm.module.scss';

interface InviteCodeFormProps {
    /** Joins the crucible a code (in its stored form) names; resolves to why it couldn't, or null once joined. */
    onJoin: (inviteCode: string) => Promise<string | null>;
    isJoining: boolean;
}

/** Where a player types the invite code a friend gave them, to join that friend's Crucible. */
export function InviteCodeForm({ onJoin, isJoining }: InviteCodeFormProps): JSX.Element {
    const [value, setValue] = useState('');
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
        event.preventDefault();
        const code = normalizeInviteCode(value);
        if (code === undefined) {
            setError(`An invite code is ${INVITE_CODE_LENGTH} letters and numbers.`);
            return;
        }
        setError(null);
        setError(await onJoin(code));
    };

    return (
        <form className={styles.inviteCodeForm} onSubmit={(event) => { void handleSubmit(event); }}>
            <label htmlFor="crucible-invite-code" className={styles.label}>Enter an invite code to join an existing crucible</label>
            <div className={styles.row}>
                <Textbox
                    id="crucible-invite-code"
                    className={styles.input}
                    value={value}
                    placeholder="ABC123"
                    spellCheck={false}
                    autoFocus
                    onChange={(event) => setValue(event.target.value)}
                />
                <Button type="submit" size="small" variant="secondary" disabled={isJoining}>Join</Button>
            </div>
            {error !== null && <p className={styles.error} role="alert">{error}</p>}
        </form>
    );
}
